/** Tiny instant-render shell while the offline Local Mode chunk loads. */
export default function StaffNotepadShell() {
  return (
    <main data-testid="staff-notepad-shell" className="min-h-[100dvh] bg-[#FAFAFA]">
      <header className="px-4 pt-5 pb-2 flex items-center justify-between">
        <div className="text-sm font-display font-semibold text-slate-900">ConfirmPH Notepad</div>
        <div className="text-[11px] text-slate-500">Loading...</div>
      </header>
      <section className="mx-4 mt-3 rounded-2xl border border-slate-200 bg-white p-4">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">Local note</div>
        <div className="mt-2 h-32 rounded-xl bg-slate-100 animate-pulse" />
        <div className="mt-3 h-9 w-32 rounded-lg bg-emerald-100 animate-pulse ml-auto" />
      </section>
      <p className="px-5 mt-4 text-[11px] text-slate-400">Opening notes saved on this device...</p>
    </main>
  );
}
